/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingsPageMeta_root$ref: FragmentReference;
declare export opaque type AggregatesListingsPageMeta_root$fragmentType: AggregatesListingsPageMeta_root$ref;
export type AggregatesListingsPageMeta_root = {|
  +cms: {|
    +pageWithData: ?{|
      +page: {|
        +description: ?string
      |}
    |}
  |},
  +$refType: AggregatesListingsPageMeta_root$ref,
|};
export type AggregatesListingsPageMeta_root$data = AggregatesListingsPageMeta_root;
export type AggregatesListingsPageMeta_root$key = {
  +$data?: AggregatesListingsPageMeta_root$data,
  +$fragmentRefs: AggregatesListingsPageMeta_root$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "lang"
    },
    {
      "kind": "RootArgument",
      "name": "uid"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingsPageMeta_root",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CMS",
      "kind": "LinkedField",
      "name": "cms",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "lang",
              "variableName": "lang"
            },
            {
              "kind": "Variable",
              "name": "uid",
              "variableName": "uid"
            }
          ],
          "concreteType": "CMSPageWithData",
          "kind": "LinkedField",
          "name": "pageWithData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CMSPage",
              "kind": "LinkedField",
              "name": "page",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '244498484a89c95611975d18eb06ad26';

export default node;
